import React from 'react';
import {
    HighlightContent,
    HighlightImage,
    HighlightTipWrapper,
    TermsWrapper,
} from 'features/Big9Tips/styled';
import { CAMPAIGN_IMAGE_PATH } from 'constants/appConfig';
import Text from 'ui/Text';
import Button from 'ui/Button';
import Spinner from '../../ecoui/UISpinner';

const TipsHighlight = ({ item = {}, status = '' }) => {
    return (
        <HighlightTipWrapper>
            {status === 'loading' ? (
                <Spinner className="top-indent-md bottom-indent-md " />
            ) : Object.keys(item).length ? (
                <>
                    <HighlightImage
                        src={CAMPAIGN_IMAGE_PATH + item.image}
                        alt={item.title}
                    />
                    <HighlightContent>
                        <Text
                            condensed
                            size="x3"
                            bold
                            padding={'0 0 10px 0'}
                            margin={'0'}
                            color={'#444'}
                        >
                            {item.title}
                        </Text>
                        {item.description && (
                            <div
                                className={'bottom-indent-lg lighter'}
                                dangerouslySetInnerHTML={{
                                    __html: item.description,
                                }}
                            />
                        )}
                        {item?.external_url &&
                            item?.button_text && (
                                <Button
                                    className={'lighter'}
                                    margin={'0'}
                                    active
                                    onClick={() =>
                                        window.open(item.external_url, '_blank')
                                    }
                                >
                                    {item.button_text}
                                </Button>
                            )}
                    </HighlightContent>
                    {item.terms ? (
                        <TermsWrapper>
                            <div
                                className={'lighter'}
                                dangerouslySetInnerHTML={{
                                    __html: item.terms,
                                }}
                            />
                        </TermsWrapper>
                    ) : null}
                </>
            ) : null}
        </HighlightTipWrapper>
    );
};

export default TipsHighlight;
